/**
 * DetailSynopsisArrowRightContainer component.
 */
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled container for the detail synopsis arrow right element.
 */
const DetailSynopsisArrowRightContainer = styled.div<React.CSSProperties>`
  cursor: pointer;
`;

export default withOpacity(DetailSynopsisArrowRightContainer);
